import { render, staticRenderFns } from "./agentHaokaOrder.vue?vue&type=template&id=4ab8b46b&scoped=true&"
import script from "./agentHaokaOrder.vue?vue&type=script&lang=js&"
export * from "./agentHaokaOrder.vue?vue&type=script&lang=js&"
import style0 from "./agentHaokaOrder.vue?vue&type=style&index=0&id=4ab8b46b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab8b46b",
  null
  
)

export default component.exports